module.exports = __webpack_public_path__ + "static/media/concept-energy-label-e.2e6acdce.svg";